// extracted by mini-css-extract-plugin
export default {"root":"TldkOThkJgCokmof0Zi0","title":"RPuN5yevY85IFHql1hdq","wave":"eEveoUQnY1uwfK4zGXuu"};